import { useAuth } from "@entities/auth";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";

export default function useVerifyMfaOtp() {
  const { verifyMFAOTP } = useAuth();
  const {
    mutate: verifyMfaOtp,
    isLoading: isVerifyingOtp,
    isSuccess: isOtpVerified,
    error: verifyOtpError,
  } = useMutation({
    mutationFn: async (data: { otp: string; mfaCode: string }) => {
      return await verifyMFAOTP(data.otp, data.mfaCode).catch(async (err) => {
        const responseBody = await err.response.json();
        if (responseBody.statusCode === 403) {
          ToastService.error("Invalid OTP. Please try again.");
        }
        throw err;
      });
    },
    options: {
      skipInvalidation: true,
    },
  });
  return {
    verifyMfaOtp,
    isVerifyingOtp,
    isOtpVerified,
    verifyOtpError,
  };
}
